/**
 * hybrid autoPlay module
 * @module hybrid/autoPlay
 */
import browser from './browser';
import { initWXConf } from './wx';

export default {
  autoplay() {
    return new Promise((resolve) => {
      const ua = (window.navigator.userAgent || '').toLowerCase();
      const isIE = ua.indexOf('trident') >= 0 || ua.indexOf('msie') >= 0;

      // 自动播放
      if (isIE) {
        // ie不自动播
        resolve(false);
      } else if (browser.client === 'wx') {
        // wx，ios自动播，and不自动播
        if (browser.platform === 'ios') {
          if (this.autoPlayInIOSWeiXin) {
            this.autoPlayInIOSWeiXin().then(() => {
              resolve(true);
            });
          }
        } else {
          resolve(false);
        }
      } else if (browser.client === 'ws' && browser.platform === 'android') { // 安卓微视不自动播
        resolve(false);
      } else {
        resolve(true);
      }
    });
  },
  autoplaySync() {
    const ua = (window.navigator.userAgent || '').toLowerCase();
    const isIE = ua.indexOf('trident') >= 0 || ua.indexOf('msie') >= 0;

    // 自动播放
    if (isIE) {
      // ie不自动播
      return false;
    } if (browser.client === 'wx') {
      // wx，ios自动播，and不自动播
      if (browser.platform === 'ios') {
        return true;
      }
      return false;
    } if (browser.client === 'ws' && browser.platform === 'android') { // 安卓微视不自动播
      return false;
    }
    return true;
  },
  autoPlayInIOSWeiXin() {
  // const defer = $.Deferred();
    return new Promise((resolve) => {
      let funcCalled = false;

      function wxReadyFunc() {
        if (funcCalled) {
          return;
        }
        funcCalled = true;
        console.log('wx hack ready');
        resolve();
      }

      initWXConf().then(() => {
        if (typeof window.WeixinJSBridge === 'undefined') {
          console.log('no WeixinJSBridge');
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', wxReadyFunc, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', wxReadyFunc);
            document.attachEvent('onWeixinJSBridgeReady', wxReadyFunc);
          }
        } else {
          window.WeixinJSBridge.invoke('getNetworkType', {}, wxReadyFunc);
        }
      });
    });
  },
};
